import axios from 'axios';

const apiLocalidade = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/localidades`,
});

export default apiLocalidade;
